<script setup>
import ApplicationIcon from '@/Components/ApplicationIcon.vue'
import ApplicationLogo from '@/Components/ApplicationLogo.vue'
import { Link, usePage } from '@inertiajs/vue3'

const page = usePage()

defineProps({
  icon: {
    type: Boolean,
    default: true
  },
  header: {
    type: Boolean,
    default: true
  }
})
</script>

<template>
  <div
    v-if="header"
    class="min-h-screen flex flex-col sm:justify-start items-center pt-6 sm:pt-0 bg-primary-950"
  >
    <div
      class="mt-4 sm:mt-10 flex w-full items-center px-4 lg:px-0"
      :class="{ 'max-w-5xl': !icon, 'justify-between': !icon, 'justify-around': icon }"
    >
      <Link href="/">
        <ApplicationIcon v-if="icon" class="h-20 w-20" />
        <ApplicationLogo v-else class="h-14" large />
      </Link>
    </div>

    <div class="w-full mt-6 py-4">
      <slot />
    </div>
  </div>
  <div v-else class="min-h-screen flex flex-col sm:justify-start items-center bg-primary-950">
    <div class="w-full items-center my-auto">
      <slot />
    </div>
  </div>
</template>
